// OnBoardingView.jsx

import {
    IntegrationView,
    KYCView,
    MerchantView,
    NotificationView,
    PayModeView,
    PGConfigurationView,
    RoutingView,
    SettlementView,
    SurchargeView,
} from '.';

import React from 'react';
import PropTypes from 'prop-types';

const OnBoardingView = props => {
    const { data } = props;
    const onboardingData = data.forms[0].sections;

    const transformedData = {};

    onboardingData.forEach(item => {
        const { type, data } = item;
        transformedData[type] = data;
    });

    return (
        <>
            <MerchantView data={transformedData?.createMerchantSection} />
            <IntegrationView data={transformedData?.integrationSection} />
            <PayModeView data={transformedData?.paymentModeSection} />
            <SettlementView data={transformedData?.settlementSection} />
            <SurchargeView data={transformedData?.surchargeSection} />
            <KYCView data={transformedData?.kycSection} />
            <PGConfigurationView
                data={transformedData?.pgConfigurationSection}
            />
            <RoutingView data={transformedData?.dynamicRoutingSection} />
            <NotificationView data={transformedData?.notificationSection} />
        </>
    );
};

OnBoardingView.propTypes = {
    data: PropTypes.object,
};

export default OnBoardingView;
